module.exports = {
    "Bloodhound": require("typeahead.js/dist/bloodhound.js"),
    "loadjQueryPlugin": function() {require("typeahead.js");}
};



//////////////////
// WEBPACK FOOTER
// ./~/typeahead.js-browserify/index.js
// module id = 221
// module chunks = 0 1